import React from 'react'
import instagram from '../../assets/instagram.png' 
import linkedin from '../../assets/linkedin.png' 
import tiktok from '../../assets/tik-tok.png' 
import './Footer.scss'

const Footer = () => {

  const goInstagram = () => {
    window.location.assign("https://www.instagram.com/shield.data/")
  }

  const goTiktok = () => {
    window.location.assign("https://www.tiktok.com/@shield.data")
  }

  const goLinkedin = () => {
    window.location.assign("https://www.linkedin.com/company/shield-data-solutions/")
  }

  return (
    <div className='footer_media'>
        <div className='footer_media_icons'>
            <img src={instagram} onClick={goInstagram} />
            <img src={tiktok} onClick={goTiktok} />
            <img src={linkedin} onClick={goLinkedin} />
        </div>
        <span><b color='#68bbe3'>©</b> Data Shield 2022</span>
    </div>
  )
}

export default Footer